import React from 'react';

const PostLinkPreview = ({ previewData, url }) => {
    if (!previewData && !url) return null;

    let data = null;
    if (previewData) {
        try {
            data = typeof previewData === 'string' ? JSON.parse(previewData) : previewData;
        } catch (error) {
            console.error("Lỗi parse link preview", error);
        }
    }

    const displayUrl = data?.url || url;
    let fallbackDomain = "";
    try {
        fallbackDomain = new URL(displayUrl).hostname;
    } catch (e) {
        fallbackDomain = "Link liên kết";
    }

    const cardStyle = {
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        border: '1px solid var(--border-color, #555)', 
        borderRadius: '12px',
        marginTop: '10px',
        marginBottom: '10px',
        backgroundColor: 'var(--bg-color, transparent)',
        overflow: 'hidden',
        color: 'var(--text-color, inherit)'
    };

    const imgStyle = {
        width: '100%',
        height: '200px',
        objectFit: 'cover',
        borderBottom: '1px solid var(--border-color, #555)',
        display: 'block'
    };

    return (
        <a 
            href={displayUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={cardStyle}
            onClick={(e) => e.stopPropagation()} 
        >
            {data?.img && (
                <img 
                    src={data.img} 
                    alt="link-preview" 
                    style={imgStyle}
                    referrerPolicy="no-referrer" 
                    onError={(e) => { e.target.style.display = 'none' }} 
                />
            )}
            <div style={{ padding: '12px 15px' }}>
                <h4 style={{ margin: '0 0 5px 0', fontSize: '15px', fontWeight: 600 }}>
                    {data?.title || fallbackDomain}
                </h4>
                {data?.description && (
                    <p style={{ margin: '0 0 8px 0', fontSize: '13px', opacity: 0.8, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                        {data.description}
                    </p>
                )}
                <span style={{ fontSize: '12px', opacity: 0.5, textTransform: 'uppercase' }}>
                    {data?.domain || fallbackDomain}
                </span>
            </div>
        </a>
    );
};

export default PostLinkPreview;